import { useSelectTaskAssigneeFieldQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(projectId: string) {
  const tuple = useSelectTaskAssigneeFieldQuery({
    variables: {
      id: projectId
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.persons.map((node) => {
        return {
          id: node.id ?? '',
          name: node.id ?? '',
          displayName: node.fullName
        };
      }) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
